import { Component, OnInit, Input, OnDestroy, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, Validators } from '@angular/forms';
import { UntypedFormControl } from '@angular/forms';
import { Observable, Subject, map, takeUntil } from 'rxjs';
import { PartnerBaseDto } from 'src/app/api/models/OK/Egis/Service/Models/DTO/partner-base-dto';
import { ProduktEnum } from 'src/app/api/models/OK/Egis/Service/Models/Entities/Enums/produkt-enum';

@Component({
    selector: 'app-partner-active-input',
    templateUrl: './partner-active-input.component.html',
    styleUrls: ['./partner-active-input.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PartnerActiveInputComponent implements OnInit, OnChanges, OnDestroy {
  filteredPartners: Observable<PartnerBaseDto[]>;
  availablePartners: PartnerBaseDto[];
  @Input() form: UntypedFormGroup;
  @Input() produktId: ProduktEnum;
  private _partners: PartnerBaseDto[];
  @Input() set partners(value: PartnerBaseDto[]) {
    this._partners = value;
    if (this.produktId && this.partners) {
      this.availablePartners = this._partners.filter((p) => p.produkter.indexOf(this.produktId) >= 0);
    } else {
      this.availablePartners = this._partners;
    }
  }

  unsubscribe$ = new Subject<void>();

  partnerCtrl = new UntypedFormControl(null, Validators.required);

  get partnerNo() {
    return this.form.get('partnerNo');
  }

  constructor() {}

  ngOnInit(): void {
    this.filteredPartners = this.partnerCtrl.valueChanges.pipe(
      takeUntil(this.unsubscribe$),
      map((partner) => (partner ? this._filter(partner) : this.availablePartners.slice().map((y) => y)))
    );
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.produktId && this.partners) {
      this.availablePartners = this._partners.filter((p) => p.produkter.indexOf(this.produktId) >= 0);
    } else {
      this.availablePartners = this._partners;
    }
    if (this._partners) {
      const partner = this.availablePartners.find((x) => x.partnerNo == this.partnerNo.value);
      this.partnerCtrl.patchValue(partner);
    }
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.unsubscribe();
  }

  private _filter(value: string): PartnerBaseDto[] {
    if (typeof value !== 'string') return;
    const filterValue = value.toLowerCase();
    return this.availablePartners.filter((option) => option.name.replace(/\s/g, '').toLowerCase().indexOf(filterValue) >= 0);
  }
  displayFn(partner: any): string {
    return partner && partner.name ? partner.name : '';
  }
  partnerSelected(event: any) {
    const partner = event.option.value as PartnerBaseDto;
    this.partnerNo.patchValue(partner.partnerNo);
  }
  onBlur() {
    const partnerVal = this.partnerCtrl.value;
    if (typeof partnerVal === 'string') {
      this.partnerNo.patchValue(null);
    }
  }
}
